import React, { useState, useEffect } from 'react';
import './Dropdown.css';
import LoadingOverlay from '../components/LoadingOverlay';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';

// Função utilitária para chamadas da API com fallback
const apiCall = async (endpoint, method = 'GET', data = null) => {
  const urls = [
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`,
    `${BASE_URL}/${endpoint}`
  ];

  for (const url of urls) {
    try {
      console.log(`🔄 Tentando ${method} em: ${url}`);
      const config = {
        method,
        headers: {
          'Content-Type': 'application/json',
        }
      };
      const token = getAuthToken();
      if (token) config.headers['Authorization'] = `Bearer ${token}`;
      
      if (data && (method === 'POST' || method === 'PUT')) {
        config.body = JSON.stringify(data);
      }

      const response = await fetch(url, config);
      
      // Aceitar códigos de status de sucesso (200-299)
      if (response.ok || (response.status >= 200 && response.status < 300)) {
        console.log(`✅ SUCESSO em: ${url} - Status: ${response.status}`);
        
        // Para DELETE ou status 204 (No Content)
        if (method === 'DELETE' || response.status === 204) {
          return { success: true, status: response.status };
        }
        
        // Verificar se há conteúdo para fazer parse JSON
        const contentType = response.headers.get('Content-Type') || '';
        if (contentType.includes('application/json')) {
          try {
            const jsonData = await response.json();
            return jsonData;
          } catch (jsonError) {
            console.log(`⚠️ Erro ao parsear JSON, mas operação foi bem-sucedida`);
            return { success: true, status: response.status };
          }
        } else {
          // Resposta sem JSON
          const textData = await response.text();
          return { success: true, status: response.status, data: textData };
        }
      }
      // O servidor respondeu com erro: mostra o motivo que ele mandou (não adianta tentar de novo)
      const corpo = await response.json().catch(() => null);
      const erroServidor = new Error(
        corpo?.mensagem || corpo?.error || corpo?.erro || corpo?.message ||
        `Erro ${response.status} em ${method} ${endpoint}`
      );
      erroServidor.respostaServidor = true;
      throw erroServidor;
    } catch (error) {
      if (error.respostaServidor) throw error;
      console.log(`❌ Erro em: ${url} - ${error.message}`);
    }
  }
  
  throw new Error(`Nenhuma URL da API funcionou para ${method} ${endpoint}. Verifique se o backend está rodando.`);
};

export default function VendasDropdown() {
  console.log('🔧 VendasDropdown renderizando...');
  
  const [vendas, setVendas] = useState([]);
  const [vendasFiltradas, setVendasFiltradas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  // Estados para formulário de venda
  const [formVenda, setFormVenda] = useState({
    aberto: false,
    orcamentoId: null,
    clienteId: null,
    oportunidadeId: null,
    editando: false,
    vendaId: null
  });
  const [statusBloqueado, setStatusBloqueado] = useState(false);
  const [dadosVendaEdicao, setDadosVendaEdicao] = useState(null);
  const [vendedores, setVendedores] = useState([]);
  const [tiposPagamento, setTiposPagamento] = useState([]);
  // Pagamento - novas estruturas
  const [configuracoesPagamento, setConfiguracoesPagamento] = useState([]); // todas ativas
  const [configuracoesFiltradas, setConfiguracoesFiltradas] = useState([]); // filtradas por tipo
  const [tipoPagamentoSelecionado, setTipoPagamentoSelecionado] = useState(null);
  const [configuracaoSelecionadaId, setConfiguracaoSelecionadaId] = useState(null);
  const [quantidadeParcelas, setQuantidadeParcelas] = useState(1);
  const [dataInicioVencimento, setDataInicioVencimento] = useState(() => new Date().toISOString().split('T')[0]);
  const [calculoPagamento, setCalculoPagamento] = useState(null);
  const [carregandoCalculo, setCarregandoCalculo] = useState(false);
  const [erroCalculo, setErroCalculo] = useState('');
  const [tipoJurosUI, setTipoJurosUI] = useState(''); // Controle visual (inclui opção SEM_JUROS)
  // Adiciona estado para tipoJurosId
  const [tipoJurosId, setTipoJurosId] = useState(1); // 1=Sem Juros, 2=Absoluto, 3=Percentual

  // Estados para popup de confirmação de pagamento (serviços)
  const [showPopupPagamentoServico, setShowPopupPagamentoServico] = useState(false);
  const [processandoConfirmarPagamentoServico, setProcessandoConfirmarPagamentoServico] = useState(false);
  const [itensPopupPagamentoServico, setItensPopupPagamentoServico] = useState([]);
  const [totalPopupPagamentoServico, setTotalPopupPagamentoServico] = useState(0);

  // Estados para popup de compartilhar link de pagamento (copiar / whatsapp / email)
  const [showPopupCompartilharPagamento, setShowPopupCompartilharPagamento] = useState(false);
  const [linkPagamentoGerado, setLinkPagamentoGerado] = useState('');
  const [linkPagamentoCopiado, setLinkPagamentoCopiado] = useState(false);
  const [emailEnviandoPagamento, setEmailEnviandoPagamento] = useState(false);
  const [statusPopupPagamento, setStatusPopupPagamento] = useState(null);
  const [clienteIdPagamentoServico, setClienteIdPagamentoServico] = useState(null);

  // Estados para filtro
  const [filtro, setFiltro] = useState('clienteId');
  const [valorFiltro, setValorFiltro] = useState('');
  const [dropdownAberto, setDropdownAberto] = useState(false);

  // Função para calcular valor final automaticamente
  const calcularValorFinal = () => {
    setTimeout(() => {
      const inputValorOrc = document.querySelector('input[name="valorOrc"]');
      const inputDesconto = document.querySelector('input[name="desconto"]');
      const inputValorFinal = document.querySelector('input[name="valorVenda"]');
      
      if (inputValorOrc && inputDesconto && inputValorFinal) {
        const valorOrcamento = parseFloat(inputValorOrc.value) || 0;
        const desconto = parseFloat(inputDesconto.value) || 0;
        const valorFinal = Math.max(0, valorOrcamento - desconto);
        inputValorFinal.value = valorFinal.toFixed(2);
      }
    }, 100);
  };

  // Calcular valor final quando o formulário de venda for aberto
  useEffect(() => {
    if (formVenda.aberto) {
      calcularValorFinal();
    }
  }, [formVenda.aberto, dadosVendaEdicao]);

  // Carregar vendas ao montar o componente
  useEffect(() => {
    fetchVendas();
    fetchVendedores();
    fetchTiposPagamento();
  fetchConfiguracoesPagamento();
  }, []);

  // Notifica AjudaWidget quando o formulário de venda de serviço abre/fecha
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('vendas-servicos-popup-state', {
      detail: { formularioAberto: formVenda.aberto }
    }));
  }, [formVenda.aberto]);

  // Fecha todos os popups quando AjudaWidget solicitar
  useEffect(() => {
    const handler = () => {
      setFormVenda({ aberto: false });
      setDadosVendaEdicao(null);
      setDropdownAberto(false);
      setTipoPagamentoSelecionado(null);
      setConfiguracaoSelecionadaId(null);
      setCalculoPagamento(null);
      setQuantidadeParcelas(1);
      setDataInicioVencimento(new Date().toISOString().split('T')[0]);
      setErroCalculo('');
    };
    window.addEventListener('vendas-servicos-fechar-todos-popups', handler);
    return () => window.removeEventListener('vendas-servicos-fechar-todos-popups', handler);
  }, []);

  // Aplicar filtro quando vendas ou valorFiltro mudarem
  useEffect(() => {
    aplicarFiltro(valorFiltro);
  }, [vendas, filtro]);

  const fetchVendas = async () => {
    try {
      setLoading(true);
      console.log('🔄 Iniciando busca de vendas...');
      
      const data = await apiCall('Vendas');
      console.log('📊 Resposta da API Vendas:', data);
      console.log('📊 Tipo de resposta:', typeof data);
      console.log('📊 É array?:', Array.isArray(data));
      
      const vendasArray = Array.isArray(data) ? data : [];
      console.log('📊 Vendas como array:', vendasArray.length, 'itens');
      
      if (vendasArray.length > 0) {
        console.log('📊 Exemplo de venda (primeira):', vendasArray[0]);
      }
      
      // 🎯 FILTRO: Apenas vendas com TipoVendaId = 2 (Venda de Serviços)
      const vendasDeServico = vendasArray.filter(venda => {
        const tipoVendaId = venda.tipoVendaId || venda.TipoVendaId;
        const ehServicoId = tipoVendaId === 2;
        
        console.log(`🔍 Venda ${venda.id || venda.Id}:`, {
          tipoVendaId: tipoVendaId,
          ehServicoId: ehServicoId,
          vendaCompleta: venda
        });
        
        if (ehServicoId) {
          console.log(`✅ Venda ${venda.id || venda.Id} tem TipoVendaId = 2 (serviço): ${tipoVendaId}`);
        } else {
          console.log(`❌ Venda ${venda.id || venda.Id} NÃO tem TipoVendaId = 2: ${tipoVendaId}`);
        }
        
        return ehServicoId;
      });
      
      console.log(`🔍 Filtro aplicado: ${vendasArray.length} vendas totais → ${vendasDeServico.length} vendas de serviços (TipoVendaId = 2)`);
      
      // Simplificar enriquecimento - apenas definir dados básicos primeiro
      const vendasEnriquecidas = vendasDeServico.map(venda => ({
        ...venda,
        nomeCliente: 'Carregando...',
        cpfCnpjCliente: 'Carregando...',
        tituloOrcamento: 'Carregando...'
      }));
      
      setVendas(vendasEnriquecidas);
      setVendasFiltradas(vendasEnriquecidas);
      setError('');
      
          // Enriquecer dados em background (sem bloquear a renderização)
          setTimeout(async () => {
            try {
              console.log('🔄 Iniciando enriquecimento de dados...');
              const vendasEnriquecidas = await Promise.all(
                vendasDeServico.map(async (venda) => {
                  try {
                    // Buscar dados do cliente
                    let nomeCliente = 'N/A';
                    let cpfCnpjCliente = 'N/A';
                    if (venda.clineteId || venda.ClienteId) {
                      try {
                        const clientes = await apiCall('Cliente');
                        const cliente = clientes.find(c => 
                          (c.id || c.Id) === (venda.clineteId || venda.ClienteId)
                        );
                        if (cliente) {
                          nomeCliente = cliente.nome || cliente.Nome || 'N/A';
                          cpfCnpjCliente = cliente.cpf_cnpj || cliente.Cpf_cnpj || cliente.cpfCnpj || cliente.CpfCnpj || 'N/A';
                        }
                      } catch (error) {
                        console.error('Erro ao buscar cliente:', error);
                      }
                    }

                    // Buscar dados do orçamento
                    let tituloOrcamento = 'N/A';
                    if (venda.orcamentoID || venda.OrcamentoID) {
                      try {
                        const orcamentos = await apiCall('Orcamento');
                        const orcamento = orcamentos.find(o => 
                          (o.id || o.Id) === (venda.orcamentoID || venda.OrcamentoID)
                        );
                        if (orcamento) {
                          tituloOrcamento = orcamento.titulo || orcamento.Titulo || orcamento.descricao || orcamento.Descricao || 'N/A';
                        }
                      } catch (error) {
                        console.error('Erro ao buscar orçamento:', error);
                      }
                    }

                    return {
                      ...venda,
                      nomeCliente,
                      cpfCnpjCliente,
                      tituloOrcamento
                    };
                  } catch (error) {
                    console.error('Erro ao enriquecer venda:', error);
                    return {
                      ...venda,
                      nomeCliente: 'N/A',
                      cpfCnpjCliente: 'N/A',
                      tituloOrcamento: 'N/A'
                    };
                  }
                })
              );

              setVendas(vendasEnriquecidas);
              setVendasFiltradas(vendasEnriquecidas);
              console.log('✅ Enriquecimento de dados concluído');
            } catch (error) {
              console.error('❌ Erro no enriquecimento:', error);
            }
          }, 100);

        } catch (error) {
          console.error('❌ Erro ao buscar vendas:', error);
          setError('Erro ao carregar vendas. Verifique se o backend está rodando.');
          setVendas([]);
          setVendasFiltradas([]);
        } finally {
          setLoading(false);
        }
      };  const fetchVendedores = async () => {
    try {
      const data = await apiCall('Vendedor');
      console.log('👨‍💼 Vendedores carregados:', data);
      setVendedores(data || []);
    } catch (error) {
      console.error('❌ Erro ao buscar vendedores:', error);
      setVendedores([]);
    }
  };

  const fetchTiposPagamento = async () => {
    try {
      // Endpoint correto do controller: TipoPagamentoController => /api/TipoPagamento
      let data = await apiCall('TipoPagamento');
      // Fallback para nome antigo se necessário
      if ((!data || data.length === 0) && !Array.isArray(data)) {
        try {
          const tentativaLegacy = await apiCall('Tipo_pagamento');
          if (Array.isArray(tentativaLegacy) && tentativaLegacy.length > 0) {
            data = tentativaLegacy;
          }
        } catch { /* ignorar */ }
      }
      console.log('💳 Tipos de pagamento carregados:', data);
      setTiposPagamento(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('❌ Erro ao buscar tipos de pagamento:', error);
      setTiposPagamento([]);
    }
  };

  // Prefill tipo de pagamento ao carregar dados da venda para edição
  useEffect(() => {
    if (dadosVendaEdicao) {
      const tpId = dadosVendaEdicao.tipoPagamentoId || dadosVendaEdicao.TipoPagamentoId;
      const cfgId = dadosVendaEdicao.configuracaoPagamentoId || dadosVendaEdicao.ConfiguracaoPagamentoId;
      const qtdParcelas = dadosVendaEdicao.quantidadeParcelas || dadosVendaEdicao.QuantidadeParcelas || 1;
      const dataVencimento = dadosVendaEdicao.dataInicioVencimento || dadosVendaEdicao.DataInicioVencimento;
      const valorOrc = dadosVendaEdicao.valorOrc || dadosVendaEdicao.ValorOrc || 0;
      const desconto = dadosVendaEdicao.desconto || dadosVendaEdicao.Desconto || 0;
      const valorOriginalBase = valorOrc - desconto;
      
      console.log('🔧 Preenchendo dados da venda em edição:', {
        tipoPagamentoId: tpId,
        configuracaoPagamentoId: cfgId,
        quantidadeParcelas: qtdParcelas,
        dataVencimento,
        valorOrc,
        desconto,
        valorOriginalBase
      });
      
      if (tpId) {
        setTipoPagamentoSelecionado(tpId);
        filtrarConfiguracoesPorTipo(tpId);
      }
      
      if (cfgId) {
        setConfiguracaoSelecionadaId(cfgId);
        
        // Buscar configuração específica para preencher dados de juros
        setTimeout(() => {
          const cfg = configuracoesPagamento.find(c => (c.id || c.Id) === cfgId);
          if (cfg) {
            const tipoJuros = cfg.tipoJuros || cfg.TipoJuros || '';
            const valor = cfg.valorJuros || cfg.ValorJuros || 0;
            const desc = cfg.configuracaoJurosDescricao || cfg.ConfiguracaoJurosDescricao || '';
            
            if (desc.includes('SEM')) {
              setTipoJurosUI('SEM_JUROS');
            } else if (tipoJuros === 'PERCENTUAL') {
              setTipoJurosUI('PERCENTUAL');
            } else if (tipoJuros === 'ABSOLUTO') {
              setTipoJurosUI('ABSOLUTO');
            }
            
            console.log('🧩 Configuração encontrada:', cfg);
          }
        }, 500);
      }
      
      if (qtdParcelas) {
        setQuantidadeParcelas(qtdParcelas);
      }
      
      if (dataVencimento) {
        const dataFormatada = new Date(dataVencimento).toISOString().split('T')[0];
        setDataInicioVencimento(dataFormatada);
      }
      
      // Executar cálculo automaticamente após todos os dados serem preenchidos
      if (cfgId && valorOriginalBase > 0) {
        setTimeout(() => {
          console.log('🔄 Executando cálculo automático para edição com valor original:', valorOriginalBase);
          executarCalculoPagamento(valorOriginalBase);
        }, 1000);
      }
    }
  }, [dadosVendaEdicao, configuracoesPagamento]);

  // useEffect para cálculo automático quando campos mudarem
  useEffect(() => {
    if (configuracaoSelecionadaId) {
      const timeout = setTimeout(() => {
        let valorOrcInput = formVenda.editando ? (dadosVendaEdicao?.valorOrc || dadosVendaEdicao?.ValorOrc || 0) : (formVenda.valorOrc || 0);
        let descontoInput = formVenda.editando ? (dadosVendaEdicao?.desconto || dadosVendaEdicao?.Desconto || 0) : 0;
        
        // Tentar capturar valor do desconto do DOM se foi alterado
        const descontoDom = document.querySelector('input[name="desconto"]');
        if (descontoDom) {
          const dVal = parseFloat(descontoDom.value);
          if (!isNaN(dVal)) descontoInput = dVal;
        }
        
        const base = (parseFloat(valorOrcInput) || 0) - (parseFloat(descontoInput) || 0);
        executarCalculoPagamento(base < 0 ? 0 : base);
      }, 500);
      
      return () => clearTimeout(timeout);
    }
  }, [configuracaoSelecionadaId, quantidadeParcelas, dadosVendaEdicao, formVenda]);

  // useEffect para observar mudanças no campo de desconto
  useEffect(() => {
    const descontoDom = document.querySelector('input[name="desconto"]');
    if (!descontoDom) return;

    const handleDescontoChange = () => {
      if (configuracaoSelecionadaId) {
        const valorOrcInput = formVenda.editando ? (dadosVendaEdicao?.valorOrc || dadosVendaEdicao?.ValorOrc || 0) : (formVenda.valorOrc || 0);
        const descontoInput = parseFloat(descontoDom.value) || 0;
        const base = (parseFloat(valorOrcInput) || 0) - descontoInput;
        executarCalculoPagamento(base < 0 ? 0 : base);
      }
    };

    descontoDom.addEventListener('input', handleDescontoChange);
    descontoDom.addEventListener('change', handleDescontoChange);

    return () => {
      descontoDom.removeEventListener('input', handleDescontoChange);
      descontoDom.removeEventListener('change', handleDescontoChange);
    };
  }, [configuracaoSelecionadaId, dadosVendaEdicao, formVenda]);

  const fetchConfiguracoesPagamento = async () => {
    try {
      const data = await apiCall('ConfiguracaoPagamento');
      console.log('🧩 Configurações de pagamento carregadas:', data);
      setConfiguracoesPagamento(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('❌ Erro ao carregar configurações de pagamento:', e);
      setConfiguracoesPagamento([]);
    }
  };

  // Abrir popup de confirmação de pagamento para venda de serviço
  const handleAbrirPopupPagamentoServico = () => {
    const valorOrc = parseFloat(dadosVendaEdicao?.valorOrc || dadosVendaEdicao?.ValorOrc || 0);
    const descontoInput = document.querySelector('#venda-serv-form input[name="desconto"]');
    const desconto = parseFloat(descontoInput?.value ?? dadosVendaEdicao?.desconto ?? dadosVendaEdicao?.Desconto ?? 0);
    const total = Math.max(0, valorOrc - desconto);
    const descricao = dadosVendaEdicao?.descricaoOrcamento || dadosVendaEdicao?.DescricaoOrcamento || 'Serviço';
    setItensPopupPagamentoServico([{ nome: descricao, valorOrc, desconto, total }]);
    setTotalPopupPagamentoServico(total);
    setShowPopupPagamentoServico(true);
  };

  // Confirmar e realizar pagamento: auto-salva com StatusVenda=Aprovada e gera checkout Stripe
  const handleConfirmarEPagarServico = async () => {
    const idVenda = formVenda.vendaId;
    if (!idVenda) { alert('ID da venda não encontrado.'); return; }

    setShowPopupPagamentoServico(false);
    setProcessandoConfirmarPagamentoServico(true);

    try {
      const form = document.getElementById('venda-serv-form');
      const formData = form ? new FormData(form) : null;

      const valorOrc = parseFloat(dadosVendaEdicao?.valorOrc || dadosVendaEdicao?.ValorOrc || 0);
      const desconto = parseFloat(formData?.get('desconto') ?? dadosVendaEdicao?.desconto ?? dadosVendaEdicao?.Desconto ?? 0);
      const valorFinal = Math.max(0, valorOrc - desconto);

      const vendaDataSave = {
        Id: idVenda,
        OrcamentoID: formVenda.orcamentoId || dadosVendaEdicao?.orcamentoID || dadosVendaEdicao?.OrcamentoID,
        ClineteId: formVenda.clienteId || dadosVendaEdicao?.clineteId || dadosVendaEdicao?.ClineteId,
        ValorOrc: valorOrc,
        Desconto: desconto,
        ValorVenda: valorFinal,
        ValorFinal: valorFinal,
        DataVenda: formData?.get('dataVenda') || dadosVendaEdicao?.dataVenda || new Date().toISOString().split('T')[0],
        StatusVenda: 'Aprovada',
        VendedorId: parseInt(formData?.get('vendedorId') || dadosVendaEdicao?.vendedorId) || null,
        TipoPagamentoId: tipoPagamentoSelecionado || dadosVendaEdicao?.tipoPagamentoId || null,
        Notas: formData?.get('notas') || dadosVendaEdicao?.notas || '',
        DescricaoOrcamento: formData?.get('descricaoOrcamento') || dadosVendaEdicao?.descricaoOrcamento || '',
        TipoVendaId: 2,
        TipoVendaNatureza: 'servico',
        TipoJurosId: 1,
      };

      console.log('💾 [Pagamento Serviço] Auto-salvando venda com StatusVenda=Aprovada:', vendaDataSave);
      await apiCall(`Vendas/${idVenda}`, 'PUT', vendaDataSave);
      console.log('✅ [Pagamento Serviço] Venda auto-salva');

      const result = await apiCall(`VendaPagamento/create-checkout/${idVenda}`, 'POST');
      if (result && result.checkoutUrl) {
        setClienteIdPagamentoServico(vendaDataSave.ClineteId || null);
        setLinkPagamentoGerado(result.checkoutUrl);
        setLinkPagamentoCopiado(false);
        setShowPopupCompartilharPagamento(true);
      } else {
        alert('Erro ao criar checkout Stripe: ' + (result?.error || result?.message || 'Erro desconhecido'));
      }
    } catch (error) {
      console.error('❌ [Pagamento Serviço] Erro:', error);
      alert('Erro ao processar pagamento: ' + (error.message || 'Erro desconhecido'));
    } finally {
      setProcessandoConfirmarPagamentoServico(false);
    }
  };

  // ==============================================
  // COMPARTILHAR LINK DE PAGAMENTO (copiar / whatsapp / email SMTP)
  // ==============================================
  const handleCopiarLinkPagamento = () => {
    if (!linkPagamentoGerado) return;
    navigator.clipboard.writeText(linkPagamentoGerado).then(() => {
      setLinkPagamentoCopiado(true);
      setTimeout(() => setLinkPagamentoCopiado(false), 3000);
    });
  };

  const handleCompartilharWhatsAppPagamento = () => {
    if (!linkPagamentoGerado) return;
    const mensagem = `Olá! Segue o link para pagamento do seu serviço:\n\n${linkPagamentoGerado}\n\nPor favor, acesse o link para concluir o pagamento com segurança.`;
    window.open(`https://wa.me/?text=${encodeURIComponent(mensagem)}`, '_blank');
  };

  const handleEnviarEmailSMTPPagamento = async () => {
    if (!linkPagamentoGerado) return;
    setEmailEnviandoPagamento(true);
    try {
      let clienteEmail = '';
      let clienteNome = '';
      if (clienteIdPagamentoServico) {
        try {
          const cliente = await apiCall(`Cliente/${clienteIdPagamentoServico}`);
          clienteEmail = cliente?.email || cliente?.Email || '';
          clienteNome = cliente?.nome || cliente?.Nome || '';
        } catch (e) {
          console.warn('Erro ao buscar cliente para email:', e);
        }
      }

      if (!clienteEmail) {
        setStatusPopupPagamento({ type: 'error', title: 'E-mail não encontrado', text: 'O cliente vinculado a esta venda não possui e-mail cadastrado.' });
        return;
      }

      const assunto = 'Link de Pagamento - S6 Gestão';
      const corpo = `<p>Prezado(a) ${clienteNome || 'cliente'},</p><p>Segue o link para pagamento do seu serviço:</p><p><a href="${linkPagamentoGerado}">${linkPagamentoGerado}</a></p><p>Por favor, acesse o link para concluir o pagamento com segurança.</p><p>Atenciosamente.</p>`;

      const token = getAuthToken();
      const headers = { 'Content-Type': 'application/json' };
      if (token) headers['Authorization'] = 'Bearer ' + token;

      const resp = await fetch(`${BASE_URL}/Relacionamento_Clientes/enviar-email`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ EmailDestinatario: clienteEmail, Assunto: assunto, TemplateHtml: corpo })
      });
      const resultado = await resp.json().catch(() => null);

      if (resp.ok) {
        setStatusPopupPagamento({ type: 'success', title: 'E-mail enviado!', text: 'E-mail enviado com sucesso!', email: clienteEmail });
      } else {
        setStatusPopupPagamento({ type: 'error', title: 'Erro ao enviar', text: resultado?.message || 'Não foi possível enviar o e-mail.' });
      }
    } catch (e) {
      setStatusPopupPagamento({ type: 'error', title: 'Erro ao enviar', text: e.message || 'Erro desconhecido.' });
    } finally {
      setEmailEnviandoPagamento(false);
    }
  };

  const filtrarConfiguracoesPorTipo = (tipoId) => {
    if (!tipoId) {
      setConfiguracoesFiltradas([]);
      return;
    }
    const filtradas = configuracoesPagamento.filter(c => (c.tipoPagamentoId || c.TipoPagamentoId) === tipoId);
    setConfiguracoesFiltradas(filtradas);
  };

  const handleTipoPagamentoChange = (e) => {
    const id = parseInt(e.target.value) || null;
    setTipoPagamentoSelecionado(id);
    setConfiguracaoSelecionadaId(null);
    setCalculoPagamento(null);
    setQuantidadeParcelas(1);
    filtrarConfiguracoesPorTipo(id);
  };

  const handleConfiguracaoChange = (e) => {
    const id = parseInt(e.target.value) || null;
    setConfiguracaoSelecionadaId(id);
    setCalculoPagamento(null); // reset cálculo para nova config
    setErroCalculo('');
    // Ajustar parcelas para máximo permitido
    const cfg = configuracoesPagamento.find(c => (c.id || c.Id) === id);
    if (cfg) {
      const maxParcelas = cfg.maximoParcelas || cfg.MaximoParcelas || 1;
      setQuantidadeParcelas(Math.min(quantidadeParcelas, maxParcelas));
      setTipoJurosUI(cfg.tipoJuros || cfg.TipoJuros || '');
      
      // Executar cálculo automaticamente quando configuração é selecionada
      setTimeout(() => {
        const valorOrc = dadosVendaEdicao?.valorOrc || dadosVendaEdicao?.ValorOrc || 0;
        const desconto = dadosVendaEdicao?.desconto || dadosVendaEdicao?.Desconto || 0;
        const valorOriginalBase = valorOrc - desconto;
        if (valorOriginalBase > 0) {
          console.log('🔄 Recalculando automaticamente após mudança de configuração com valor original:', valorOriginalBase);
          executarCalculoPagamento(valorOriginalBase);
        }
      }, 100);
    }
  };

  const executarCalculoPagamento = (valorOriginalBase) => {
    if (!configuracaoSelecionadaId) {
      setErroCalculo('');
      return;
    }
    setErroCalculo('');
    setCarregandoCalculo(true);
    try {
      const cfg = configuracoesPagamento.find(c => (c.id || c.Id) === configuracaoSelecionadaId) || {};
      const tipoJuros = (cfg.tipoJuros || cfg.TipoJuros || '').toUpperCase();
      const taxa = parseFloat(cfg.valorJuros ?? cfg.ValorJuros) || 0;
      const descricaoJuros = (cfg.configuracaoJurosDescricao || cfg.ConfiguracaoJurosDescricao || '').toUpperCase();
      const modalidade = (cfg.modalidadePagamentoDescricao || cfg.ModalidadePagamentoDescricao || '').toUpperCase();
      const isAVista = modalidade.includes('VISTA');
      const temJuros = descricaoJuros.includes('COM') && taxa > 0 && tipoJuros !== '';
      const qtd = Math.max(1, parseInt(quantidadeParcelas) || 1);

      let valorOriginal = valorOriginalBase;
      let valorComJuros = valorOriginal;
      let valorJuros = 0;
      let observacao = '';

      if (temJuros) {
        if (tipoJuros === 'ABSOLUTO') {
          valorJuros = taxa;
          valorComJuros = valorOriginal + valorJuros;
          observacao = `Juros absoluto R$ ${valorJuros.toFixed(2)}`;
        } else if (tipoJuros === 'PERCENTUAL') {
          if (!isAVista && qtd > 1) {
            const fator = 1 + (taxa / 100);
            valorComJuros = valorOriginal * Math.pow(fator, qtd);
            valorJuros = valorComJuros - valorOriginal;
            observacao = `Juros composto ${taxa}% por parcela (${qtd}x)`;
          } else {
            valorJuros = (valorOriginal * taxa) / 100;
            valorComJuros = valorOriginal + valorJuros;
            observacao = `Juros simples ${taxa}%`;
          }
        }
      } else {
        observacao = 'Sem juros';
      }

      const valorParcelaBruto = valorComJuros / qtd;
      // Gerar parcelas com ajuste final
      const parcelas = [];
      for (let i = 1; i <= qtd; i++) {
        let valorParcela = valorParcelaBruto;
        if (i === qtd) {
          const somaAnteriores = valorParcelaBruto * (qtd - 1);
            valorParcela = valorComJuros - somaAnteriores;
        }
        const data = new Date(dataInicioVencimento || new Date().toISOString().split('T')[0]);
        data.setMonth(data.getMonth() + (i - 1));
        parcelas.push({
          numeroParcela: i,
          valorParcela: valorParcela,
          dataVencimento: data.toISOString(),
          observacoes: i === qtd ? 'Parcela final (ajuste)' : null
        });
      }

      const simulacao = {
        valorOriginal,
        valorJuros,
        valorFinal: valorComJuros,
        quantidadeParcelas: qtd,
        valorParcela: valorParcelaBruto,
        parcelas,
        observacaoCalculo: observacao + ' (simulação local)'
      };

      setCalculoPagamento(simulacao);
    } catch (e) {
      setErroCalculo('Erro ao simular: ' + (e.message || 'desconhecido'));
    } finally {
      setCarregandoCalculo(false);
    }
  };

  const fetchVendaPorId = async (vendaId) => {
    try {
      setLoading(true);
      console.log('🔍 Buscando venda por ID:', vendaId);
      const data = await apiCall(`Vendas/${vendaId}`);
      console.log('📄 Dados da venda:', data);
      setDadosVendaEdicao(data);
      return data;
    } catch (error) {
      console.error('❌ Erro ao buscar venda por ID:', error);
      alert('Erro ao carregar dados da venda');
      return null;
    } finally {
      setLoading(false);
    }
  };

  // Funções de filtro
  const handleFiltroChange = (novoFiltro) => {
    setFiltro(novoFiltro);
    setDropdownAberto(false);
    setValorFiltro('');
    // Resetar para todas as vendas quando muda o filtro
    setVendasFiltradas(vendas);
  };

  const handleInputChange = (e) => {
    const valor = e.target.value;
    setValorFiltro(valor);
    aplicarFiltro(valor);
  };

  const aplicarFiltro = (valor) => {
    if (!valor.trim()) {
      setVendasFiltradas(vendas);
      return;
    }

    const filtradas = vendas.filter(venda => {
      if (filtro === 'clienteId') {
        const clienteId = (venda.clineteId || venda.ClienteId || '').toString();
        return clienteId.toLowerCase().includes(valor.toLowerCase());
      }
      if (filtro === 'vendaId') {
        const vendaId = (venda.id || venda.Id || '').toString();
        return vendaId.toLowerCase().includes(valor.toLowerCase());
      }
      if (filtro === 'orcamentoId') {
        const orcamentoId = (venda.orcamentoID || venda.OrcamentoID || '').toString();
        return orcamentoId.toLowerCase().includes(valor.toLowerCase());
      }
      if (filtro === 'valor') {
        const valorVenda = (venda.valorVenda || venda.ValorVenda || 0).toString();
        return valorVenda.includes(valor);
      }
      if (filtro === 'status') {
        const status = venda.statusVenda || venda.StatusVenda || '';
        return status.toLowerCase().includes(valor.toLowerCase());
      }
      return true;
    });

    setVendasFiltradas(filtradas);
  };

  // Função para aprovar venda e gerar contas a receber automaticamente
  const aprovarVenda = async (vendaId) => {
    try {
      console.log(`🔄 Aprovando venda de serviço ${vendaId}...`);
      
      const response = await apiCall(`Vendas/aprovar/${vendaId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      console.log('✅ Venda aprovada com sucesso!');
      
      // Recarregar as vendas para atualizar o status
      await fetchVendas();
      
      alert('Venda aprovada com sucesso! Contas a receber e contrato gerados automaticamente.');
      
    } catch (error) {
      console.error('❌ Erro ao aprovar venda:', error);
      alert('Erro ao aprovar venda. Tente novamente.');
    }
  };

  return (
    <div className="container-geral fundo-branco" style={{ 
      minHeight: '100vh', 
      background: '#f0f0f0', 
      padding: '20px'
    }}>
      
      {/* Filtro de vendas */}
      <div className="filtro-container">
        <div className="filtro-wrapper">
          <input
            type="text"
            placeholder={`Filtrar por ${
              filtro === 'clienteId' ? 'Cliente ID' :
              filtro === 'vendaId' ? 'Venda ID' :
              filtro === 'orcamentoId' ? 'Orçamento ID' :
              filtro === 'valor' ? 'Valor' :
              filtro === 'status' ? 'Status' : 'Selecione um filtro'
            }...`}
            value={valorFiltro}
            onChange={handleInputChange}
            disabled={!filtro}
            className="filtro-input"
          />
          <div className="dropdown-wrapper">
            <button
              className="dropdown-button"
              onClick={() => setDropdownAberto(!dropdownAberto)}
            >
              {filtro === 'clienteId' ? 'Cliente ID' :
               filtro === 'vendaId' ? 'Venda ID' :
               filtro === 'orcamentoId' ? 'Orçamento ID' :
               filtro === 'valor' ? 'Valor' :
               filtro === 'status' ? 'Status' : 'Filtrar por'}
              <span className="dropdown-arrow">▼</span>
            </button>
            {dropdownAberto && (
              <div className="dropdown-menu">
                <div
                  className="dropdown-item"
                  onClick={() => handleFiltroChange('clienteId')}
                >
                  Cliente ID
                </div>
                <div
                  className="dropdown-item"
                  onClick={() => handleFiltroChange('vendaId')}
                >
                  Venda ID
                </div>
                <div
                  className="dropdown-item"
                  onClick={() => handleFiltroChange('orcamentoId')}
                >
                  Orçamento ID
                </div>
                <div
                  className="dropdown-item"
                  onClick={() => handleFiltroChange('valor')}
                >
                  Valor
                </div>
                <div
                  className="dropdown-item"
                  onClick={() => handleFiltroChange('status')}
                >
                  Status
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Estado de loading */}
      {loading && (
        <div style={{ 
          textAlign: 'center', 
          padding: '40px', 
          color: '#666' 
        }}>
          Carregando vendas...
        </div>
      )}

      {/* Estado de erro */}
      {error && (
        <div style={{ 
          textAlign: 'center', 
          padding: '20px', 
          color: '#ff0000',
          backgroundColor: '#ffebee',
          borderRadius: '5px',
          margin: '20px 0'
        }}>
          {error}
        </div>
      )}

      {/* Lista de vendas */}
      {!loading && !error && (
        <div className="oportunidade-cards">
          {vendasFiltradas.length === 0 ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '40px', 
              color: '#666',
              backgroundColor: 'white',
              marginTop: '10px'
            }}>
              {valorFiltro ? 'Nenhuma venda encontrada para o filtro aplicado' : 'Nenhuma venda encontrada'}
            </div>
          ) : (
            vendasFiltradas.map((venda, index) => (
              <div className="card-cliente venda-servico-card" key={venda.id || venda.Id || index} style={{ display: 'flex', borderBottom: '1px solid #000', padding: '10px 0' }}>
                <div className="venda-servico-card-fields" style={{ width: '80%', display: 'flex', flexDirection: 'row', gap: '20px', padding: '10px 0' }}>
                  {/* Coluna ID da Venda */}
                  <div className="venda-field venda-field-id" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>ID Venda</label>
                    <span>{venda.id || venda.Id || 'N/A'}</span>
                  </div>
                  
                  {/* Coluna ID Cliente */}
                  <div className="venda-field venda-field-cliente-id" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>ID Cliente</label>
                    <span>{venda.clineteId || venda.ClienteId || 'N/A'}</span>
                  </div>
                  
                  {/* Coluna Orçamento ID */}
                  <div className="venda-field venda-field-orcamento" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Orçamento ID</label>
                    <span>{venda.orcamentoID || venda.OrcamentoID || 'N/A'}</span>
                  </div>
                  
                  {/* Coluna Cliente (Nome) */}
                  <div className="venda-field venda-field-cliente" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Cliente</label>
                    <span>{venda.nomeCliente || venda.NomeCliente || 'N/A'}</span>
                  </div>
                  
                  {/* Coluna Orçamento (Título) */}
                  <div className="venda-field venda-field-orcamento-titulo" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Orçamento</label>
                    <span>{venda.tituloOrcamento || venda.TituloOrcamento || 'N/A'}</span>
                  </div>
                  
                  {/* Coluna CPF/CNPJ */}
                  <div className="venda-field venda-field-cpfcnpj" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>CPF/CNPJ</label>
                    <span>{venda.cpfCnpjCliente || venda.CpfCnpjCliente || 'N/A'}</span>
                  </div>
                  
                  {/* Coluna Valor */}
                  <div className="venda-field venda-field-valor" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Valor Final</label>
                    <span style={{ color: '#28a745', fontWeight: '600' }}>
                      R$ {(venda.valorVenda || venda.ValorVenda || 0).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </span>
                  </div>
                  
                  {/* Coluna Status */}
                  <div className="venda-field venda-field-status" style={{ display: 'flex', flexDirection: 'column' }}>
                    <label style={{ fontWeight: 'bold', marginBottom: '5px' }}>Status</label>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: '500',
                      backgroundColor: getStatusColor(venda.statusVenda || venda.StatusVenda).bg,
                      color: getStatusColor(venda.statusVenda || venda.StatusVenda).text
                    }}>
                      {venda.statusVenda || venda.StatusVenda || 'Pendente'}
                    </span>
                  </div>
                </div>
                <div className="venda-card-actions" style={{ width: '25%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
                  <button
                    className="botao-editar"
                    onClick={async () => {
                      try {
                        setLoading(true);
                        console.log('Editar venda:', venda.id);
                        
                        // ✅ RESET: Limpar todos os states de configuração de pagamento antes de abrir
                        console.log('🔄 Resetando states de configuração de pagamento...');
                        setTipoPagamentoSelecionado(null);
                        setConfiguracaoSelecionadaId(null);
                        setConfiguracoesFiltradas([]);
                        setQuantidadeParcelas(1);
                        setDataInicioVencimento(new Date().toISOString().split('T')[0]);
                        setCalculoPagamento(null);
                        setErroCalculo('');
                        setTipoJurosUI('');
                        setCarregandoCalculo(false);
                        
                        const vendaId = venda.id || venda.Id;
                        const dadosVenda = await fetchVendaPorId(vendaId);
                        let clienteId = dadosVenda.clineteId || dadosVenda.ClienteId;
                        let orcamentoId = dadosVenda.orcamentoID || dadosVenda.OrcamentoID;
                        // Buscar orçamento para garantir o cliente correto
                        if (orcamentoId) {
                          try {
                            const orcamento = await apiCall(`Orcamento/${orcamentoId}`);
                            if (orcamento && (orcamento.id_cliente || orcamento.Id_cliente)) {
                              clienteId = orcamento.id_cliente || orcamento.Id_cliente;
                            }
                          } catch (e) {
                            console.warn('Não foi possível buscar orçamento para preencher clienteId:', e);
                          }
                        }
                        if (dadosVenda) {
                          setFormVenda({
                            aberto: true,
                            editando: true,
                            vendaId: vendaId,
                            orcamentoId: orcamentoId,
                            clienteId: clienteId
                          });
                        }
                      } catch (error) {
                        console.error('❌ Erro ao abrir edição:', error);
                        alert('Erro ao abrir edição da venda');
                      } finally {
                        setLoading(false);
                      }
                    }}
                    title="Editar venda"
                  >
                    <span className="btn-edit-icon" aria-hidden>✎</span>
                    <span className="btn-edit-text">Editar</span>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {/* Formulário de Nova Venda */}
      {formVenda.aberto && (
        <div className="popup-agendamento-overlay" onClick={() => {
          // ✅ RESET: Limpar todos os states de configuração de pagamento ao fechar
          console.log('🔄 Resetando states ao fechar via overlay...');
          setTipoPagamentoSelecionado(null);
          setConfiguracaoSelecionadaId(null);
          setConfiguracoesFiltradas([]);
          setQuantidadeParcelas(1);
          setDataInicioVencimento(new Date().toISOString().split('T')[0]);
          setCalculoPagamento(null);
          setErroCalculo('');
          setTipoJurosUI('');
          setCarregandoCalculo(false);
          
          setFormVenda({ aberto: false });
          setDadosVendaEdicao(null);
        }}>
          <div className="popup-agendamento" onClick={e => e.stopPropagation()} style={{ 
            position: 'relative', 
            maxWidth: '900px', 
            width: '90%',
            maxHeight: '85vh',
            overflowY: 'auto'
          }}>
            <button
              className="popup-fechar-btn"
              onClick={() => {
                // ✅ RESET: Limpar todos os states de configuração de pagamento ao fechar
                console.log('🔄 Resetando states ao fechar modal...');
                setTipoPagamentoSelecionado(null);
                setConfiguracaoSelecionadaId(null);
                setConfiguracoesFiltradas([]);
                setQuantidadeParcelas(1);
                setDataInicioVencimento(new Date().toISOString().split('T')[0]);
                setCalculoPagamento(null);
                setErroCalculo('');
                setTipoJurosUI('');
                setCarregandoCalculo(false);
                
                setFormVenda({ aberto: false });
                setDadosVendaEdicao(null);
              }}
              aria-label="Fechar"
            >
              ×
            </button>
            <div className="popup-agendamento-centro">
              <div className="popup-titulo-laranja">
                {formVenda.editando ? 'EDITAR VENDA' : 'NOVA VENDA'}
              </div>
              
              <form id="venda-serv-form" className="formulario-venda" onSubmit={async (e) => {
                e.preventDefault();
                const formData = new FormData(e.target);
                
                // Validações antes de enviar
                const valorOrc = parseFloat(formData.get('valorOrc')) || 0;
                const desconto = parseFloat(formData.get('desconto')) || 0;
                
                // Validar se desconto não é maior que valor do orçamento
                if (desconto > valorOrc) {
                  alert(`Erro: Desconto (R$ ${desconto.toFixed(2)}) não pode ser maior que o valor do orçamento (R$ ${valorOrc.toFixed(2)})`);
                  return;
                }
                
                // Calcular valor final correto
                const valorFinalCalculado = valorOrc - desconto;
                
                const tipoPagamentoId = parseInt(tipoPagamentoSelecionado) || null;
                const valorOriginalBase = valorFinalCalculado; // base sem juros
                const usarCalculo = !!calculoPagamento && configuracaoSelecionadaId;

                // Ao construir o payload:
                const mapTipoJurosId = {
                  'SEM_JUROS': 1,
                  'ABSOLUTO': 2,
                  'PERCENTUAL': 3
                };
                const vendaDataBase = {
                  OrcamentoID: formVenda.orcamentoId,
                  ClineteId: formVenda.clienteId,
                  ValorOrc: valorOrc,
                  Desconto: desconto,
                  ValorVenda: usarCalculo ? calculoPagamento.valorFinal : valorOriginalBase,
                  DataVenda: formData.get('dataVenda') || new Date().toISOString().split('T')[0],
                  StatusVenda: formData.get('statusVenda') || 'Pendente',
                  VendedorId: parseInt(formData.get('vendedorId')) || null,
                  TipoPagamentoId: tipoPagamentoId,
                  Notas: formData.get('notas') || '',
                  Impostos: 0,
                  DescricaoOrcamento: formData.get('descricaoOrcamento') || '',
                  TipoVendaId: 2, // sempre serviço
                  TipoVendaNatureza: 'servico', // natureza da venda: serviço
                  TipoJurosId: mapTipoJurosId[tipoJurosUI] || 1 // envia conforme select
                };

                // Acrescentar campos de pagamento avançado se houver cálculo
                let vendaData = usarCalculo ? {
                  ...vendaDataBase,
                  ConfiguracaoPagamentoId: configuracaoSelecionadaId,
                  ValorOriginal: calculoPagamento.valorOriginal,
                  ValorJuros: calculoPagamento.valorJuros,
                  ValorFinal: calculoPagamento.valorFinal,
                  QuantidadeParcelas: calculoPagamento.quantidadeParcelas,
                  ValorParcela: calculoPagamento.valorParcela
                } : vendaDataBase;

                // Observação: agora os DadosCartao serão enviados SOMENTE quando for edição (PUT).
                // Não anexamos DadosCartao no POST de criação da venda.

                try {
                  if (formVenda.editando) {
                    // PUT aceita objeto direto
                    vendaData.Id = formVenda.vendaId;

                    // Anexar DadosCartao apenas na edição (PUT) se o tipo selecionado for cartão
                    try {
                      const tp = tiposPagamento.find(t => (t.id || t.Id) === tipoPagamentoId);
                      const descricaoTp = (tp?.descricaoPagamento || tp?.DescricaoPagamento || '').toString().toLowerCase();
                      if (descricaoTp.includes('cart') || descricaoTp.includes('cartão')) {
                        const numeroCartao = formData.get('numeroCartao') || null;
                        const nomeTitular = formData.get('nomeTitular') || null;
                        const mesVencimento = formData.get('mesVencimento') || null;
                        const anoVencimento = formData.get('anoVencimento') || null;
                        const codigoSeguranca = formData.get('codigoSeguranca') || null;

                        vendaData = {
                          ...vendaData,
                          DadosCartao: {
                            NumeroCartao: numeroCartao,
                            NomeTitular: nomeTitular,
                            MesVencimento: mesVencimento,
                            AnoVencimento: anoVencimento,
                            CodigoSeguranca: codigoSeguranca
                          }
                        };
                      }
                    } catch (err) {
                      console.warn('Não foi possível anexar DadosCartao ao payload de edição:', err);
                    }

                    console.log('📤 Editando venda:', vendaData);
                    const response = await apiCall(`Vendas/${formVenda.vendaId}`, 'PUT', vendaData);
                    console.log('✅ Venda editada:', response);

                    // Se o tipo de pagamento for cartão, criar pagamento através do endpoint de pagamentos
                    try {
                      const tp = tiposPagamento.find(t => (t.id || t.Id) === tipoPagamentoId);
                      const descricaoTp = (tp?.descricaoPagamento || tp?.DescricaoPagamento || '').toString().toLowerCase();
                      if (descricaoTp.includes('cart') || descricaoTp.includes('cartão')) {
                        // Obter venda atualizada para pegar o valor final salvo
                        const vendaGet = await apiCall(`Vendas/${formVenda.vendaId}`);
                        const vendaIdConfirm = vendaGet.id || vendaGet.Id || formVenda.vendaId;
                        const valorParaPagamento = vendaGet.valorFinal || vendaGet.ValorFinal || vendaGet.valorVenda || vendaGet.ValorVenda || vendaData.ValorVenda || vendaData.ValorFinal || 0;

                        const numeroCartao = formData.get('numeroCartao') || null;
                        const nomeTitular = formData.get('nomeTitular') || null;
                        const mesVencimento = formData.get('mesVencimento') || null;
                        const anoVencimento = formData.get('anoVencimento') || null;
                        const codigoSeguranca = formData.get('codigoSeguranca') || null;

                        const criarPagamentoPayload = {
                          VendaId: vendaIdConfirm,
                          TipoPagamento: 'credit_card',
                          Valor: parseFloat(valorParaPagamento) || 0,
                          QuantidadeParcelas: quantidadeParcelas || 1,
                          DadosCartao: {
                            NumeroCartao: numeroCartao,
                            NomeTitular: nomeTitular,
                            MesVencimento: mesVencimento,
                            AnoVencimento: anoVencimento,
                            CodigoSeguranca: codigoSeguranca
                          }
                        };

                        console.log('📤 Criando pagamento via /api/Pagamento/criar:', criarPagamentoPayload);
                        const pagamentoResp = await apiCall('Pagamento/criar', 'POST', criarPagamentoPayload);
                        console.log('✅ Resposta do pagamento:', pagamentoResp);
                      }
                    } catch (err) {
                      console.warn('Erro ao criar pagamento automático após PUT:', err);
                    }

                    // Após editar, faz GET da venda para confirmar status
                    const vendaGet = await apiCall(`Vendas/${formVenda.vendaId}`, 'GET');
                    
                    // Verificar se a venda foi aprovada para mostrar notificação adequada
                    const statusAtual = vendaGet.statusVenda || vendaGet.StatusVenda;
                    const statusAnterior = dadosVendaEdicao?.statusVenda || dadosVendaEdicao?.StatusVenda;
                    
                    if (statusAtual === 'Aprovada') {
                      setStatusBloqueado(true);
                      
                      // Se o status mudou para aprovada, mostrar notificação sobre automações
                      if (statusAnterior !== 'Aprovada') {
                        const confirmarNavegacao = window.confirm(
                          '✅ Venda aprovada com sucesso!\n\n' +
                          '🔄 Processamentos automáticos iniciados:\n' +
                          '• Contas a Receber geradas automaticamente\n' +
                          '• Contrato será criado (se aplicável)\n' +
                          '• Estoque reservado (para produtos)\n\n' +
                          '📋 Deseja ir para Contas a Receber para visualizar os novos registros?'
                        );
                        
                        if (confirmarNavegacao) {
                          // Navegar para ContasReceberDropdown
                          window.location.href = '/sidebar/ContasReceberDropdown';
                        }
                      } else {
                        alert('Venda editada com sucesso!');
                      }
                    } else {
                      setStatusBloqueado(false);
                      alert('Venda editada com sucesso!');
                    }
                  } else {
                    // POST requer wrapper CriarVendaRequest
                    const payloadPost = {
                      Venda: vendaData,
                      ConfiguracaoPagamentoId: configuracaoSelecionadaId || null,
                      QuantidadeParcelas: quantidadeParcelas,
                      DataInicioVencimento: dataInicioVencimento
                    };
                    console.log('📤 Enviando venda (request wrapper):', payloadPost);
                    const response = await apiCall('Vendas', 'POST', payloadPost);
                    console.log('✅ Venda criada:', response);
                    alert('Venda criada com sucesso!');
                  }
                  
                  // ✅ RESET: Limpar todos os states de configuração de pagamento após salvar
                  console.log('🔄 Resetando states após salvar...');
                  setTipoPagamentoSelecionado(null);
                  setConfiguracaoSelecionadaId(null);
                  setConfiguracoesFiltradas([]);
                  setQuantidadeParcelas(1);
                  setDataInicioVencimento(new Date().toISOString().split('T')[0]);
                  setCalculoPagamento(null);
                  setErroCalculo('');
                  setTipoJurosUI('');
                  setCarregandoCalculo(false);
                  
                  setFormVenda({ aberto: false });
                  setDadosVendaEdicao(null);
                  fetchVendas(); // Recarregar lista de vendas
                } catch (error) {
                  console.error('❌ Erro ao salvar venda:', error);
                  alert('Erro ao salvar venda: ' + error.message);
                }
              }} style={{ display: 'flex', flexDirection: 'column', gap: '15px', padding: '15px' }}>
                
                {/* Campo oculto tipoVendaId sempre 2 */}
                <input type="hidden" name="tipoVendaId" value="2" />
                
                {/* Verificar se a venda está aprovada para bloquear campos */}
                {(() => {
                  const vendaAprovada = formVenda.editando && dadosVendaEdicao && 
                    (dadosVendaEdicao.statusVenda === 'Aprovada' || dadosVendaEdicao.StatusVenda === 'Aprovada');
                  
                  return (
                    <>
                      {vendaAprovada && (
                        <div style={{
                          background: '#fff3cd',
                          border: '1px solid #ffeaa7',
                          borderRadius: '6px',
                          padding: '12px',
                          marginBottom: '15px',
                          color: '#856404'
                        }}>
                          <strong>⚠️ Venda Aprovada:</strong> Esta venda já foi aprovada e não pode ser editada. Todos os campos estão bloqueados.
                        </div>
                      )}
                
                {/* Campos pré-preenchidos (readonly) */}
                <div id="venda-serv-secao-geral" className="venda-grid venda-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
                  <div>
                    <label style={{ color: '#111', marginBottom: '5px', display: 'block', fontSize: '15px', fontWeight: 400 }}>
                      Cliente ID
                    </label>
                    <input
                      type="text"
                      value={formVenda.clienteId || ''}
                      readOnly
                      style={{
                        width: '75%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: '#f5f5f5'
                      }}
                    />
                  </div>
                  
                  <div>
                    <label style={{ color: '#111', marginBottom: '5px', display: 'block', fontSize: '15px', fontWeight: 400 }}>
                      Orçamento ID
                    </label>
                    <input
                      type="text"
                      value={formVenda.orcamentoId || ''}
                      readOnly
                      style={{
                        width: '75%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: '#f5f5f5'
                      }}
                    />
                  </div>
                </div>

                {/* Campos editáveis */}
                <div id="venda-serv-secao-valores" className="venda-grid venda-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
                  <div>
                    <label style={{ color: '#111', marginBottom: '5px', display: 'block', fontSize: '15px', fontWeight: 400 }}>
                      Valor Orçamento (R$) (não editável)
                    </label>
                    <input
                      type="number"
                      name="valorOrc"
                      defaultValue={formVenda.editando ? (dadosVendaEdicao?.valorOrc || dadosVendaEdicao?.ValorOrc || '') : (formVenda.valorOrc || '')}
                      placeholder={"R$ 0,00"}
                      step="0.01"
                      min="0"
                      readOnly
                      style={{
                        width: '75%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'not-allowed'
                      }}
                    />
                  </div>
                  
                  <div>
                    <label style={{ color: '#111', marginBottom: '5px', display: 'block', fontSize: '15px', fontWeight: 400 }}>
                      Desconto (R$)
                    </label>
                    <input
                      type="number"
                      name="desconto"
                      defaultValue={formVenda.editando ? (dadosVendaEdicao?.desconto || dadosVendaEdicao?.Desconto || '0') : '0'}
                      placeholder={"R$ 0,00"}
                      step="0.01"
                      min="0"
                      max={formVenda.editando ? (dadosVendaEdicao?.valorOrc || dadosVendaEdicao?.ValorOrc || 0) : (formVenda.valorOrc || 0)}
                      disabled={vendaAprovada}
                      onChange={(e) => {
                        const valorOrcamento = parseFloat(formVenda.editando ? (dadosVendaEdicao?.valorOrc || dadosVendaEdicao?.ValorOrc || 0) : (formVenda.valorOrc || 0));
                        const desconto = parseFloat(e.target.value) || 0;
                        
                        // Validar se desconto não é maior que valor do orçamento
                        if (desconto > valorOrcamento) {
                          alert(`Desconto não pode ser maior que o valor do orçamento (R$ ${valorOrcamento.toFixed(2)})`);
                          e.target.value = valorOrcamento;
                          return;
                        }
                        
                        // Calcular valor final automaticamente
                        const valorFinal = valorOrcamento - desconto;
                        const inputValorFinal = document.querySelector('input[name="valorVenda"]');
                        if (inputValorFinal) {
                          inputValorFinal.value = valorFinal.toFixed(2);
                        }
                      }}
                      style={{
                        width: '75%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: vendaAprovada ? '#f5f5f5' : '#fff',
                        cursor: vendaAprovada ? 'not-allowed' : 'text'
                      }}
                    />
                  </div>
                </div>

                <div className="venda-grid venda-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
                  <div>
                    <label style={{ color: '#111', marginBottom: '5px', display: 'block', fontSize: '15px', fontWeight: 400 }}>
                      Valor Final da Venda (R$) (calculado automaticamente)
                    </label>
                    <input
                      type="number"
                      name="valorVenda"
                      defaultValue={formVenda.editando ? 
                        ((dadosVendaEdicao?.valorOrc || dadosVendaEdicao?.ValorOrc || 0) - (dadosVendaEdicao?.desconto || dadosVendaEdicao?.Desconto || 0)).toFixed(2) : 
                        (formVenda.valorOrc || 0)}
                      placeholder={"R$ 0,00"}
                      step="0.01"
                      min="0"
                      readOnly
                      required
                      style={{
                        width: '75%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'not-allowed'
                      }}
                    />
                  </div>
                  
                  <div>
                    <label style={{ color: '#111', marginBottom: '5px', display: 'block', fontSize: '15px', fontWeight: 400 }}>
                      Data da Venda
                    </label>
                    <input
                      type="date"
                      name="dataVenda"
                      defaultValue={formVenda.editando ? (dadosVendaEdicao?.dataVenda || dadosVendaEdicao?.DataVenda || '') : new Date().toISOString().split('T')[0]}
                      required
                      style={{
                        width: '75%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px'
                      }}
                    />
                  </div>
                </div>

                <div id="venda-serv-secao-status" className="venda-grid venda-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
                  <div>
                    <label style={{ color: '#111', marginBottom: '5px', display: 'block', fontSize: '15px', fontWeight: 400 }}>
                      Status da Venda
                    </label>
                    <select
                      name="statusVenda"
                      defaultValue={formVenda.editando ? (dadosVendaEdicao?.statusVenda || dadosVendaEdicao?.StatusVenda || 'Pendente') : 'Pendente'}
                      disabled={statusBloqueado || vendaAprovada}
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: (statusBloqueado || vendaAprovada) ? '#f5f5f5' : 'white',
                        color: (statusBloqueado || vendaAprovada) ? '#888' : 'inherit',
                        cursor: (statusBloqueado || vendaAprovada) ? 'not-allowed' : 'pointer'
                      }}
                    >
                      <option value="Pendente">Pendente</option>
                      <option value="Aprovada">Aprovada</option>
                      <option value="Rejeitada">Rejeitada</option>
                      <option value="Cancelada">Cancelada</option>
                    </select>
                  </div>
                  
                  <div>
                    <label style={{ color: '#111', marginBottom: '5px', display: 'block', fontSize: '15px', fontWeight: 400 }}>
                      Vendedor
                    </label>
                    <select
                      name="vendedorId"
                      defaultValue={formVenda.editando ? (dadosVendaEdicao?.vendedorId || dadosVendaEdicao?.VendedorId || '') : ''}
                      disabled={vendaAprovada}
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: vendaAprovada ? '#f5f5f5' : '#fff',
                        cursor: vendaAprovada ? 'not-allowed' : 'pointer'
                      }}
                    >
                      <option value="">Selecione um vendedor</option>
                      {vendedores.map(vendedor => (
                        <option key={vendedor.id || vendedor.Id} value={vendedor.id || vendedor.Id}>
                          {vendedor.nomeVendedor || vendedor.NomeVendedor}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div id="venda-serv-secao-pagamento" className="venda-grid venda-grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
                  <div>
                    <label style={{ color: '#111', marginBottom: '5px', display: 'block', fontSize: '15px', fontWeight: 400 }}>
                      Tipo de Pagamento
                    </label>
                    {/* Não editável: o tipo vem do meio que o cliente usou no Stripe */}
                    <select
                      name="tipoPagamentoId"
                      value={tipoPagamentoSelecionado || ''}
                      onChange={handleTipoPagamentoChange}
                      disabled
                      title="Definido automaticamente pelo Stripe"
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        backgroundColor: '#f5f5f5',
                        cursor: 'not-allowed'
                      }}
                    >
                      <option value="">Aguardando pagamento no Stripe</option>
                      {tiposPagamento.map(tipo => (
                        <option key={tipo.id || tipo.Id} value={tipo.id || tipo.Id}>
                          {tipo.descricaoPagamento || tipo.DescricaoPagamento}
                        </option>
                      ))}
                    </select>
                    <div style={{ fontSize: 12, color: '#777', marginTop: 4 }}>Definido automaticamente pelo meio usado no Stripe (Pix, boleto ou cartão).</div>
                  </div>
                </div>

                <div>
                  <label style={{ fontWeight: 400, color: '#222', fontSize: '15px', marginBottom: '5px', display: 'block' }}>
                    Descrição do Orçamento
                  </label>
                  <textarea
                    name="descricaoOrcamento"
                    rows="3"
                    defaultValue={formVenda.editando ? (dadosVendaEdicao?.descricaoOrcamento || dadosVendaEdicao?.DescricaoOrcamento || '') : ''}
                    disabled={vendaAprovada}
                    style={{
                      width: '100%',
                      padding: '8px',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      resize: 'vertical',
                      backgroundColor: vendaAprovada ? '#f5f5f5' : '#fff',
                      cursor: vendaAprovada ? 'not-allowed' : 'text'
                    }}
                    placeholder="Descrição opcional do orçamento..."
                  />
                </div>

                <div>
                  <label style={{ fontWeight: 400, color: '#222', fontSize: '15px', marginBottom: '5px', display: 'block' }}>
                    Notas Adicionais
                  </label>
                  <textarea
                    name="notas"
                    rows="3"
                    defaultValue={formVenda.editando ? (dadosVendaEdicao?.notas || dadosVendaEdicao?.Notas || '') : ''}
                    disabled={vendaAprovada}
                    style={{
                      width: '100%',
                      padding: '8px',
                      border: '1px solid #ddd',
                      borderRadius: '4px',
                      resize: 'vertical',
                      backgroundColor: vendaAprovada ? '#f5f5f5' : '#fff',
                      cursor: vendaAprovada ? 'not-allowed' : 'text'
                    }}
                    placeholder="Notas adicionais sobre a venda..."
                  />
                </div>

                {/* Botões */}
                <div className="venda-form-actions" style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px' }}>
                  <button
                    type="button"
                    onClick={() => {
                      // ✅ RESET: Limpar todos os states de configuração de pagamento ao cancelar
                      console.log('🔄 Resetando states ao cancelar...');
                      setTipoPagamentoSelecionado(null);
                      setConfiguracaoSelecionadaId(null);
                      setConfiguracoesFiltradas([]);
                      setQuantidadeParcelas(1);
                      setDataInicioVencimento(new Date().toISOString().split('T')[0]);
                      setCalculoPagamento(null);
                      setErroCalculo('');
                      setTipoJurosUI('');
                      setCarregandoCalculo(false);
                      
                      setFormVenda({ aberto: false });
                      setDadosVendaEdicao(null);
                    }}
                    style={{
                      padding: '10px 20px',
                      backgroundColor: '#666',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontWeight: 'bold'
                    }}
                  >
                    Cancelar
                  </button>
                  {vendaAprovada && (
                    <button
                      type="button"
                      onClick={handleAbrirPopupPagamentoServico}
                      disabled={processandoConfirmarPagamentoServico}
                      style={{
                        padding: '10px 20px',
                        background: processandoConfirmarPagamentoServico ? '#ccc' : 'linear-gradient(135deg, #635bff 0%, #7c3aed 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: processandoConfirmarPagamentoServico ? 'not-allowed' : 'pointer',
                        fontWeight: 'bold',
                        boxShadow: processandoConfirmarPagamentoServico ? 'none' : '0 2px 8px rgba(99,91,255,0.4)',
                      }}
                    >
                      {processandoConfirmarPagamentoServico ? '⏳ Processando...' : '💳 Realizar Pagamento'}
                    </button>
                  )}
                  <button
                    type="submit"
                    disabled={vendaAprovada}
                    style={{
                      padding: '10px 20px',
                      backgroundColor: vendaAprovada ? '#ccc' : 'rgb(235, 133, 0)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: vendaAprovada ? 'not-allowed' : 'pointer',
                      fontWeight: 'bold'
                    }}
                  >
                    {formVenda.editando ? 'Editar Venda' : 'Criar Venda'}
                  </button>
                </div>
                    </>
                  );
                })()}
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ===== POPUP CONFIRMAÇÃO PAGAMENTO STRIPE (SERVIÇOS) ===== */}
      {showPopupPagamentoServico && (
        <div
          onClick={() => !processandoConfirmarPagamentoServico && setShowPopupPagamentoServico(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 12, padding: '32px 28px', maxWidth: 520, width: '92%', boxShadow: '0 8px 32px rgba(0,0,0,0.25)', maxHeight: '88vh', overflowY: 'auto' }}
          >
            <div style={{ fontSize: 36, textAlign: 'center', marginBottom: 8 }}>💳</div>
            <h3 style={{ margin: '0 0 6px', color: '#1a237e', textAlign: 'center', fontSize: 20 }}>Confirmar Pagamento</h3>
            <p style={{ color: '#555', textAlign: 'center', marginBottom: 20, fontSize: 14 }}>
              Revise os dados da venda antes de prosseguir ao Stripe:
            </p>

            {/* Tabela de itens */}
            <div style={{ border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden', marginBottom: 16 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#f5f5f5' }}>
                    <th style={{ padding: '10px 12px', textAlign: 'left', color: '#333', fontWeight: 600 }}>Descrição</th>
                    <th style={{ padding: '10px 8px', textAlign: 'right', color: '#333', fontWeight: 600, whiteSpace: 'nowrap' }}>Valor Orç.</th>
                    <th style={{ padding: '10px 8px', textAlign: 'right', color: '#333', fontWeight: 600 }}>Desconto</th>
                    <th style={{ padding: '10px 12px', textAlign: 'right', color: '#333', fontWeight: 600 }}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {itensPopupPagamentoServico.map((it, idx) => (
                    <tr key={idx} style={{ borderTop: '1px solid #eee' }}>
                      <td style={{ padding: '10px 12px', color: '#333' }}>{it.nome}</td>
                      <td style={{ padding: '10px 8px', textAlign: 'right', color: '#555', whiteSpace: 'nowrap' }}>R$ {it.valorOrc.toFixed(2)}</td>
                      <td style={{ padding: '10px 8px', textAlign: 'right', color: '#c62828', whiteSpace: 'nowrap' }}>- R$ {it.desconto.toFixed(2)}</td>
                      <td style={{ padding: '10px 12px', textAlign: 'right', color: '#333', fontWeight: 500, whiteSpace: 'nowrap' }}>R$ {it.total.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Total */}
            <div style={{ background: '#e8f5e9', borderRadius: 8, padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, border: '1px solid #c8e6c9' }}>
              <span style={{ fontSize: 16, fontWeight: 700, color: '#1b5e20' }}>Valor Final Total:</span>
              <span style={{ fontSize: 22, fontWeight: 800, color: '#2e7d32' }}>R$ {totalPopupPagamentoServico.toFixed(2)}</span>
            </div>

            <p style={{ color: '#e65100', fontSize: 12, textAlign: 'center', marginBottom: 20, background: '#fff3e0', padding: '8px 12px', borderRadius: 6, border: '1px solid #ffe0b2', lineHeight: 1.5 }}>
              ℹ️ O status da venda será automaticamente atualizado para <strong>Aprovada</strong> antes de redirecionar ao Stripe.
            </p>

            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              <button
                onClick={() => setShowPopupPagamentoServico(false)}
                style={{ padding: '11px 26px', borderRadius: 8, border: 'none', background: '#6c757d', color: '#fff', fontSize: 15, fontWeight: 600, cursor: 'pointer' }}
              >
                Cancelar
              </button>
              <button
                onClick={handleConfirmarEPagarServico}
                style={{ padding: '11px 26px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #635bff 0%, #7c3aed 100%)', color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 12px rgba(99,91,255,0.4)' }}
              >
                ✅ Confirmar Realizar Pagamento
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== POPUP COMPARTILHAR LINK DE PAGAMENTO ===== */}
      {showPopupCompartilharPagamento && (
        <div
          onClick={() => setShowPopupCompartilharPagamento(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 16, padding: '32px 28px', maxWidth: 440, width: '92%', boxShadow: '0 8px 32px rgba(0,0,0,0.25)', position: 'relative' }}
          >
            <button
              onClick={() => setShowPopupCompartilharPagamento(false)}
              style={{ position: 'absolute', top: 14, right: 14, width: 32, height: 32, borderRadius: '50%', border: 'none', background: '#ff9800', color: '#fff', fontSize: 18, fontWeight: 700, cursor: 'pointer', lineHeight: '32px', textAlign: 'center', padding: 0 }}
            >
              ×
            </button>

            <h3 style={{ margin: '0 0 8px', color: '#1a237e', fontSize: 20 }}>Compartilhar Link de Pagamento</h3>
            <p style={{ color: '#555', marginBottom: 20, fontSize: 14, lineHeight: 1.5 }}>
              O link de pagamento foi gerado com sucesso. Copie o link, envie por WhatsApp ou por e-mail para o cliente.
            </p>

            <div style={{ background: '#f5f5f5', border: '1px solid #e0e0e0', borderRadius: 8, padding: '10px 12px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ flex: 1, fontFamily: 'monospace', fontSize: 12, color: '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {linkPagamentoGerado}
              </span>
              <button
                onClick={handleCopiarLinkPagamento}
                style={{ padding: '6px 14px', borderRadius: 6, border: 'none', background: linkPagamentoCopiado ? '#2e7d32' : '#635bff', color: '#fff', fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}
              >
                {linkPagamentoCopiado ? '✓ Copiado!' : 'Copiar'}
              </button>
            </div>

            <div style={{ display: 'flex', gap: 20, justifyContent: 'center' }}>
              <button
                onClick={handleCompartilharWhatsAppPagamento}
                title="Compartilhar via WhatsApp"
                style={{ width: 72, height: 72, borderRadius: '50%', border: 'none', background: '#25D366', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <svg viewBox="0 0 24 24" width="34" height="34" fill="#fff">
                  <path d="M12.04 2c-5.52 0-10 4.48-10 10 0 1.77.46 3.45 1.27 4.9L2 22l5.25-1.38A9.94 9.94 0 0012.04 22c5.52 0 10-4.48 10-10s-4.48-10-10-10zm0 18.15c-1.6 0-3.13-.43-4.45-1.24l-.32-.19-3.12.82.83-3.04-.2-.31A8.14 8.14 0 013.9 12c0-4.5 3.66-8.15 8.15-8.15 4.5 0 8.15 3.66 8.15 8.15 0 4.5-3.66 8.15-8.16 8.15zm4.47-6.1c-.24-.12-1.44-.71-1.66-.79-.22-.08-.39-.12-.55.12-.16.24-.63.79-.78.95-.14.16-.29.18-.53.06-.24-.12-1.02-.38-1.94-1.2-.72-.64-1.2-1.43-1.35-1.67-.14-.24-.02-.37.11-.49.11-.11.24-.29.36-.43.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.55-1.33-.76-1.82-.2-.48-.4-.42-.55-.42-.14-.01-.3-.01-.46-.01-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.7 2.6 4.12 3.64.58.25 1.03.4 1.38.51.58.18 1.11.16 1.53.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.46-.28z"/>
                </svg>
              </button>
              <button
                onClick={handleEnviarEmailSMTPPagamento}
                disabled={emailEnviandoPagamento}
                title="Enviar por e-mail"
                style={{ width: 72, height: 72, borderRadius: '50%', border: 'none', background: '#1976d2', cursor: emailEnviandoPagamento ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: emailEnviandoPagamento ? 0.7 : 1 }}
              >
                {emailEnviandoPagamento ? (
                  <span style={{ fontSize: 28 }}>⏳</span>
                ) : (
                  <svg viewBox="0 0 24 24" width="32" height="32" fill="#fff">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== POPUP STATUS ENVIO EMAIL PAGAMENTO ===== */}
      {statusPopupPagamento && (
        <div
          onClick={() => setStatusPopupPagamento(null)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100000 }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: 16, padding: '32px 28px', maxWidth: 400, width: '90%', boxShadow: '0 8px 32px rgba(0,0,0,0.3)', textAlign: 'center' }}
          >
            <div style={{ fontSize: 44, marginBottom: 12 }}>
              {statusPopupPagamento.type === 'success' ? '✅' : '❌'}
            </div>
            <h3 style={{ margin: '0 0 12px', color: statusPopupPagamento.type === 'success' ? '#2e7d32' : '#c62828', fontSize: 19 }}>
              {statusPopupPagamento.title}
            </h3>
            {statusPopupPagamento.email ? (
              <div style={{ background: '#e8f5e9', border: '1px solid #c8e6c9', borderRadius: 8, padding: '10px 14px', marginBottom: 12, color: '#2e7d32', fontWeight: 600, fontSize: 14, wordBreak: 'break-all' }}>
                {statusPopupPagamento.email}
              </div>
            ) : null}
            <p style={{ color: '#555', fontSize: 14, lineHeight: 1.5, marginBottom: 20 }}>
              {statusPopupPagamento.text}
            </p>
            <button
              onClick={() => setStatusPopupPagamento(null)}
              style={{ padding: '10px 28px', borderRadius: 8, border: 'none', background: '#635bff', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
            >
              Fechar
            </button>
          </div>
        </div>
      )}

      <LoadingOverlay isLoading={loading} message="Processando..." />
    </div>
  );
}

// Função auxiliar para cores do status
function getStatusColor(status) {
  const statusLower = (status || '').toLowerCase();
  
  switch (statusLower) {
    case 'aprovado':
    case 'concluído':
    case 'finalizado':
      return { bg: '#d4edda', text: '#155724' };
    case 'pendente':
    case 'pendente aprovação':
      return { bg: '#fff3cd', text: '#856404' };
    case 'rejeitado':
    case 'cancelado':
      return { bg: '#f8d7da', text: '#721c24' };
    case 'em andamento':
    case 'processando':
      return { bg: '#d1ecf1', text: '#0c5460' };
    default:
      return { bg: '#e2e3e5', text: '#383d41' };
  }
}
